import { CheckCircle } from "lucide-react";

interface SolutionItem {
  title: string;
  description: string;
}

interface UseCaseSolutionProps {
  solutions: SolutionItem[];
  accentColor: string;
}

const UseCaseSolution = ({ solutions, accentColor }: UseCaseSolutionProps) => {
  return (
    <section className="relative py-20 lg:py-24 bg-[#0A0A0F]">
      {/* Accent glow */}
      <div className="absolute inset-0">
        <div
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] rounded-full blur-[150px] opacity-10"
          style={{ backgroundColor: accentColor }}
        />
      </div>

      <div className="container relative z-10 mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Section header */}
          <div className="mb-12 animate-fade-up">
            <div className="flex items-center gap-3 mb-4">
              <div className="h-1 w-8 rounded-full bg-[#10B981]" />
              <span className="text-sm font-medium uppercase tracking-wider text-white/50">
                La solution
              </span>
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-white">
              Avec B<span style={{ color: accentColor }}>8</span>ild
            </h2>
          </div>

          {/* Solutions grid */}
          <div className="grid gap-4 sm:grid-cols-2">
            {solutions.map((solution, index) => (
              <div
                key={index}
                className="group relative rounded-xl p-[1px] bg-gradient-to-b from-[#10B981]/20 to-transparent animate-fade-up hover:from-[#10B981]/30 transition-all duration-300"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="rounded-xl bg-[#0F0F14]/80 backdrop-blur-xl p-5 h-full">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 h-10 w-10 rounded-lg bg-[#10B981]/10 flex items-center justify-center group-hover:scale-110 transition-transform">
                      <CheckCircle className="h-5 w-5 text-[#10B981]" />
                    </div>
                    <div>
                      <h3 className="text-white font-semibold mb-1">
                        {solution.title}
                      </h3>
                      <p className="text-white/50 text-sm leading-relaxed">
                        {solution.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default UseCaseSolution;
